import React, { FC } from 'react';
import { ReactComponent as Info } from './assets/Info.svg';
import { ReactComponent as Profile } from './assets/Profile.svg';
import { ReactComponent as Money } from './assets/Money.svg';
import { ReactComponent as CreditCard } from './assets/CreditCard.svg';
import { ReactComponent as Logo } from './assets/Logo.svg';
import { ReactComponent as QrSuccess } from './assets/QrSuccess.svg';
import { ReactComponent as Email } from './assets/Email.svg';
import { ReactComponent as Back } from './assets/Back.svg';
import { ReactComponent as Next } from './assets/Next.svg';
import { ReactComponent as Error } from './assets/Error.svg';
import { ReactComponent as ApplePay } from './assets/ApplePay.svg';
import { ReactComponent as GooglePay } from './assets/GooglePay.svg';
import { ReactComponent as Amex } from './assets/Amex.svg';
import { ReactComponent as Mastercard } from './assets/Mastercard.svg';
import { ReactComponent as Visa } from './assets/Visa.svg';
import { ReactComponent as Star } from './assets/Star.svg';
import { ReactComponent as Msg } from './assets/Msg.svg';
import { ReactComponent as Receipt } from './assets/Receipt.svg';
import { ReactComponent as Success } from './assets/Success.svg';
import { ReactComponent as Close } from './assets/Close.svg';
import { ReactComponent as QR } from './assets/QR.svg';
import { ReactComponent as Coin } from './assets/Coin.svg';
import { ReactComponent as GiroPay } from './assets/GiroPay.svg';
import { ReactComponent as Ideal } from './assets/Ideal.svg';
import { ReactComponent as SplitCard } from './assets/SplitCard.svg';
import { ReactComponent as MetaMask } from './assets/MetaMask_Fox.svg';
import { ReactComponent as Sofort } from './assets/Sofort.svg';
import { ReactComponent as UpDown } from './assets/UpDown.svg';
import { ReactComponent as Copy } from './assets/Copy.svg';
import { ReactComponent as Copied } from './assets/Copied.svg';
import { ReactComponent as Edit } from './assets/Edit.svg';
import { ReactComponent as Fanz } from './assets/Fanz.svg';
import { ReactComponent as ArrowRight } from './assets/ArrowRight.svg';
import { ReactComponent as Paypal } from './assets/PaypalLogo.svg';
import { ReactComponent as Cancel } from './assets/Cancel.svg';
import { ReactComponent as PayByBank } from './assets/PayByBank.svg';
import { ReactComponent as Twint } from './assets/Twint.svg';
import { ReactComponent as Wero } from './assets/Wero.svg';
import { ReactComponent as Eps } from './assets/Eps.svg';

export enum Icons {
  SplitCard = 'splitcard',
  Logo = 'logo',
  Info = 'info',
  Profile = 'profile',
  Money = 'money',
  CreditCard = 'creditcard',
  ApplePay = 'applePay',
  GooglePay = 'googlePay',
  QrSuccess = 'qrSuccess',
  Back = 'back',
  Next = 'next',
  Email = 'email',
  Amex = 'amex',
  MasterCard = 'mastercard',
  VISA = 'visa',
  Error = 'error',
  Star = 'star',
  Message = 'message',
  Receipt = 'receipt',
  Success = 'success',
  Close = 'close',
  QR = 'qr',
  Coin = 'coin',
  MetaMask = 'metamask',
  UpDown = 'upDown',
  Copy = 'copy',
  Copied = 'copied',
  Edit = 'edit',
  Fanz = 'fanz',
  ArrowRight = 'arrowRight',
  Paypal = 'paypal',
  Cancel = 'cancel',
  PayByBank = 'payByBank',
  Twint = 'twint',
  Wero = 'wero',
  Eps = 'eps',
}

interface IconProps {
  name: string;
}

const Icon: FC<IconProps> = (props: IconProps) => {
  const { name } = props;
  switch (name) {
    case Icons.SplitCard:
      return <SplitCard {...props} />;
    case Icons.Logo:
      return <Logo {...props} />;
    case Icons.Info:
      return <Info {...props} />;
    case Icons.Profile:
      return <Profile {...props} />;
    case Icons.Money:
      return <Money {...props} />;
    case Icons.CreditCard:
      return <CreditCard {...props} />;
    case Icons.ApplePay:
      return <ApplePay {...props} />;
    case Icons.GooglePay:
      return <GooglePay {...props} />;
    case Icons.QrSuccess:
      return <QrSuccess {...props} />;
    case Icons.Back:
      return <Back {...props} />;
    case Icons.Next:
      return <Next {...props} />;
    case Icons.Email:
      return <Email {...props} />;
    case Icons.Amex:
      return <Amex {...props} />;
    case Icons.MasterCard:
      return <Mastercard {...props} />;
    case Icons.VISA:
      return <Visa {...props} />;
    case Icons.Error:
      return <Error {...props} />;
    case Icons.Star:
      return <Star {...props} />;
    case Icons.Message:
      return <Msg {...props} />;
    case Icons.Receipt:
      return <Receipt {...props} />;
    case Icons.Success:
      return <Success {...props} />;
    case Icons.Close:
      return <Close {...props} />;
    case Icons.QR:
      return <QR {...props} />;
    case Icons.Coin:
      return <Coin {...props} />;
    case 'giroPay':
      return <GiroPay {...props} />;
    case 'ideal':
      return <Ideal {...props} />;
    case 'metamask':
      return <MetaMask {...props} />;
    case Icons.UpDown:
      return <UpDown {...props} />;
    case Icons.Copy:
      return <Copy {...props} />;
    case Icons.Copied:
      return <Copied {...props} />;
    case Icons.Edit:
      return <Edit {...props} />;
    case Icons.Fanz:
      return <Fanz {...props} />;
    case Icons.ArrowRight:
      return <ArrowRight {...props} />;
    case Icons.Paypal:
      return <Paypal {...props} />;
    case Icons.Cancel:
      return <Cancel {...props} />;
    case Icons.PayByBank:
      return <PayByBank {...props} />;
    case Icons.Twint:
      return <Twint {...props} />;
    case Icons.Wero:
      return <Wero {...props} />;
    case Icons.Eps:
      return <Eps {...props} />;
    default:
      return null;
  }
};

export default Icon;
export {
  SplitCard,
  Logo,
  Info,
  Profile,
  Money,
  CreditCard,
  QrSuccess,
  Email,
  Amex,
  Back,
  Next,
  Error,
  Mastercard,
  Visa,
  Msg,
  Receipt,
  Success,
  Close,
  QR,
  Coin,
  GiroPay,
  Ideal,
  Sofort,
  UpDown,
  Copy,
  Copied,
  Edit,
  Fanz,
  ArrowRight,
  Paypal,
  Cancel,
  PayByBank,
  Twint,
  Wero,
  Eps,
};
